import { IDeviceEdgeAgentPropertiesDto, IDeviceEdgeModuleDto } from 'shared/api/api';

export const REGISTER_SITE_DEVICES = 'REGISTER_SITE_DEVICES';
export const GET_DEVICE_PROXY_PROPERTIES = 'GET_DEVICE_PROXY_PROPERTIES';
export const SET_DEVICE_PROXY_PROPERTIES = 'SET_DEVICE_PROXY_PROPERTIES';
export const GET_DEVICE_EDGE_AGENT_PROPERTIES = 'GET_DEVICE_EDGE_AGENT_PROPERTIES';
export const GET_DEVICE_CONNECTION_STRING = 'GET_DEVICE_CONNECTION_STRING';
export const RESET_IOT_HUB_STATE = 'RESET_IOT_HUB_STATE';

export interface IotHubState {
	edgeModule?: IDeviceEdgeModuleDto;
	edgeAgent?: IDeviceEdgeAgentPropertiesDto;
	connectionString?: string;
	isLoading: boolean;
	error?: string;
}
